import Web3 from "web3";
import { toast } from 'react-toastify'
import contractAbi from './../utils/abis/token.json';
import { ENV } from './../config/config';
import store from './../store'
import { axiosSyncPost } from './../utils/functions';
import { SET_WALLET_ERROR, REDIRECT_TO_WALLET } from './../redux/types';

let Contract = require('web3-eth-contract');
const nftContractAddress = ENV.nftContractAddress;
let requiredChainId = ENV.requiredChainId;
Contract.setProvider(
    // new Web3.providers.HttpProvider(
    //     ENV.web3ProviderAddress,
    //     {
    //         headers: [{
    //             name: 'Access-Control-Allow-Origin',
    //             value: ENV.web3ProviderAddress
    //         }]
    //     }
    // )
    new Web3(Web3.givenProvider || new Web3.providers.WebsocketProvider(ENV.web3ProviderAddress))
);

export const getWeb3 = async () => {
    if (window.ethereum) {
        const web3 = new Web3(Web3.givenProvider);
        return web3;
    }
    else {
        return false;
    }
}
export const connectMetamask = async () => {
    if (window.ethereum) {
        const web3 = await getWeb3();
        await window.ethereum.enable();
        let accounts = await web3.eth.getAccounts();
        let chainId = await web3.eth.getChainId();
        if (chainId !== requiredChainId) {
            store.dispatch(setWalletError(`Please switch to ${ENV.requiredChainName} in order to use all features of Marketplace`));
        }
        return accounts[0];
    }
    else {
        store.dispatch(setWalletError("Please install Metamask Wallet in order to use all features of Marketplace"));
    }
}
export const signRequest = async () => {
    if (window.ethereum) {
        const web3 = await getWeb3();
        let accounts = await web3.eth.getAccounts();
        let address = accounts[0];
        let signature = await handleSignMessage(address);
        return signature;
    }
    else {
        alert("Please install Metamask in order to use all features of Marketplace");
    }
}
export const mint = async (_nftData, _id) => {
    const web3 = await getWeb3();
    if (!web3) {
        toast.error("No web3 instance found");
        return false;
    }
    try {
        let connectedAddress = await connectMetamask();
        _nftData.creator = connectedAddress;
        let tokenContract = new Contract(contractAbi, nftContractAddress);
        const txCount = await web3.eth.getTransactionCount(connectedAddress);
        let types = ["address", "string"];
        let payload = [_nftData.creator, _nftData.metaData]
        let hash = await createHash(types, payload)
        let signature = await handleSignMessageWithHash(hash, connectedAddress)
        const myNewData = await tokenContract.methods
            .createNFTs(_nftData, hash, signature, _nftData.copies)
            .encodeABI();
        const gasLimit = await web3.eth.estimateGas({
            from: connectedAddress,
            nonce: txCount,
            to: nftContractAddress,
            data: myNewData,
        });
        const gas2 = await web3.eth.getGasPrice();
        const transactionParameters = {
            nonce: web3.utils.toHex(txCount), // ignored by MetaMask
            gasPrice: web3.utils.toHex(gas2), // customizable by user during MetaMask confirmation.
            gasLimit: web3.utils.toHex(gasLimit), // customizable by user during MetaMask confirmation.
            to: nftContractAddress, // Required except during contract publications.
            from: connectedAddress, // must match user's active address.
            data: myNewData, // Optional, but used for defining smart contract creation and interaction.
        };
        // throw new Error()
        // As with any RPC call, it may throw an error
        const txHash = await window.ethereum.request({
            method: 'eth_sendTransaction',
            params: [transactionParameters],
        });
        let txDetails = await getTransactionDetails(txHash)
        if (!txDetails.status) {
            let payloadData = {
                _id
            }
            axiosSyncPost('nfts/unset', payloadData)
        }
        let blockNumber = txDetails.blockNumber;
        console.log("blockNumberblockNumberblockNumberblockNumberblockNumberblockNumber");
        console.log(blockNumber);
        const tokenEvents = await tokenContract.getPastEvents('NewNFTs', {
            fromBlock: blockNumber,
        });
        console.log("tokenEventstokenEventstokenEventstokenEventstokenEvents");
        console.log(tokenEvents);
        let tokenIds = tokenEvents[0].returnValues[0];
        return { tokenIds, txHash };
    } catch (e) {
        let payloadData = {
            _id
        }
        axiosSyncPost('nfts/unset', payloadData)
        // let eMessage = e.message.split('{')[0] || '';
        // toast.error(eMessage);
        toast.error('Sorry, unable to create an item/NFT for you')
        return false;
    }
}
export const changeSellingStatusWeb3 = async (_nftData) => {
    const web3 = await getWeb3();
    if (!web3) {
        toast.error("No web3 instance found");
        return false;
    }
    try {
        let connectedAddress = await connectMetamask();
        let tokenContract = new Contract(contractAbi, nftContractAddress);
        const txCount = await web3.eth.getTransactionCount(connectedAddress);
        let weiPrice = web3.utils.toWei(_nftData.price, 'ether');

        const myNewData = await tokenContract.methods
            .changeSellingStatus(_nftData.tokenId, _nftData.selling, weiPrice)
            .encodeABI();
        // const gasLimit = await web3.eth.estimateGas({
        //     from: connectedAddress,
        //     nonce: txCount,
        //     to: nftContractAddress,
        //     data: myNewData,
        // });
        // const gas2 = await web3.eth.getGasPrice();
        const transactionParameters = {
            nonce: web3.utils.toHex(txCount), // ignored by MetaMask
            // gasPrice: web3.utils.toHex(gas2), // customizable by user during MetaMask confirmation.
            // gasLimit: web3.utils.toHex(gasLimit), // customizable by user during MetaMask confirmation.
            to: nftContractAddress, // Required except during contract publications.
            from: connectedAddress, // must match user's active address.
            data: myNewData, // Optional, but used for defining smart contract creation and interaction.
        };
        // As with any RPC call, it may throw an error
        const txHash = await window.ethereum.request({
            method: 'eth_sendTransaction',
            params: [transactionParameters],
        });
        let txDetails = await getTransactionDetails(txHash)
        if (!txDetails.status) {
            return false;
        }
        return true;
    } catch (e) {
        console.log(e);
        let eMessage = e.message.split('{')[0] || '';
        toast.error(eMessage);
        return false;
    }
}
export const makeOfferWeb3 = async (_nftData) => {
    const web3 = await getWeb3();
    if (!web3) {
        toast.error("No web3 instance found");
        return false;
    }
    try {
        let connectedAddress = await connectMetamask();
        let cabi = JSON.parse(_nftData.cabi);
        let cAddress = _nftData.cAddress;
        let approvedAmount = await isApproved(nftContractAddress, connectedAddress, cAddress, cabi);
        let weiPrice = web3.utils.toWei(`${_nftData.price}`, 'ether');

        if (parseInt(weiPrice) > parseInt(approvedAmount)) {
            let cabi = JSON.parse(_nftData.cabi);
            let cAddress = _nftData.cAddress;
            let gotApproval = await getApproval(nftContractAddress, ENV.amountToApprove, cAddress, cabi)
            if (!gotApproval) {
                return false;
            }
        }

        let tokenContract = new Contract(contractAbi, nftContractAddress);
        const txCount = await web3.eth.getTransactionCount(connectedAddress);
        let types = ["uint256", "uint256"];
        let payload = [_nftData.tokenId, _nftData.price]
        let hash = await createHash(types, payload)
        let signature = await handleSignMessageWithHash(hash, connectedAddress);

        const myNewData = await tokenContract.methods
            .placeOffer(_nftData.tokenId, weiPrice, hash, signature)
            .encodeABI();
        const gasLimit = await web3.eth.estimateGas({
            from: connectedAddress,
            nonce: txCount,
            to: nftContractAddress,
            data: myNewData,
        });
        const gas2 = await web3.eth.getGasPrice();
        const transactionParameters = {
            nonce: web3.utils.toHex(txCount), // ignored by MetaMask
            gasPrice: web3.utils.toHex(gas2), // customizable by user during MetaMask confirmation.
            gasLimit: web3.utils.toHex(gasLimit), // customizable by user during MetaMask confirmation.
            to: nftContractAddress, // Required except during contract publications.
            from: connectedAddress, // must match user's active address.
            data: myNewData, // Optional, but used for defining smart contract creation and interaction.
        };
        // As with any RPC call, it may throw an error
        const txHash = await window.ethereum.request({
            method: 'eth_sendTransaction',
            params: [transactionParameters],
        });
        let txDetails = await getTransactionDetails(txHash)
        if (!txDetails.status) {
            return false;
        }
        return txHash;
    } catch (e) {
        console.log(e);
        let eMessage = e.message.split('{')[0] || '';
        toast.error(eMessage);
        return false;
    }
}
export const placeBidWeb3 = async (_nftData) => {
    const web3 = await getWeb3();
    if (!web3) {
        toast.error("No web3 instance found");
        return false;
    }
    try {
        let connectedAddress = await connectMetamask();
        let cabi = JSON.parse(_nftData.cabi);
        let cAddress = _nftData.cAddress;
        let approvedAmount = await isApproved(nftContractAddress, connectedAddress, cAddress, cabi);
        let weiPrice = web3.utils.toWei(`${_nftData.price}`, 'ether');

        if (parseInt(weiPrice) > parseInt(approvedAmount)) {
            let cabi = JSON.parse(_nftData.cabi);
            let cAddress = _nftData.cAddress;
            let gotApproval = await getApproval(nftContractAddress, ENV.amountToApprove, cAddress, cabi)
            if (!gotApproval) {
                return false;
            }
        }
        let tokenContract = new Contract(contractAbi, nftContractAddress);
        const txCount = await web3.eth.getTransactionCount(connectedAddress);
        let types = ["uint256", "uint256"];
        let payload = [_nftData.tokenId, _nftData.price]
        let hash = await createHash(types, payload)
        let signature = await handleSignMessageWithHash(hash, connectedAddress);

        const myNewData = await tokenContract.methods
            .placeBid(_nftData.tokenId, weiPrice, hash, signature)
            .encodeABI();
        const gasLimit = await web3.eth.estimateGas({
            from: connectedAddress,
            nonce: txCount,
            to: nftContractAddress,
            data: myNewData,
        });
        const gas2 = await web3.eth.getGasPrice();
        const transactionParameters = {
            nonce: web3.utils.toHex(txCount), // ignored by MetaMask
            gasPrice: web3.utils.toHex(gas2), // customizable by user during MetaMask confirmation.
            gasLimit: web3.utils.toHex(gasLimit), // customizable by user during MetaMask confirmation.
            to: nftContractAddress, // Required except during contract publications.
            from: connectedAddress, // must match user's active address.
            data: myNewData, // Optional, but used for defining smart contract creation and interaction.
        };
        // As with any RPC call, it may throw an error
        const txHash = await window.ethereum.request({
            method: 'eth_sendTransaction',
            params: [transactionParameters],
        });
        let txDetails = await getTransactionDetails(txHash)
        if (!txDetails.status) {
            return false;
        }
        return txHash;
    } catch (e) {
        console.log(e);
        let eMessage = e.message.split('{')[0] || '';
        toast.error(eMessage);
        return false;
    }
}
export const cancelOfferBidWeb3 = async (_nftData) => {
    const web3 = await getWeb3();
    if (!web3) {
        toast.error("No web3 instance found");
        return false;
    }
    try {
        let connectedAddress = await connectMetamask();
        let tokenContract = new Contract(contractAbi, nftContractAddress);
        const txCount = await web3.eth.getTransactionCount(connectedAddress);
        let types = ["uint256", "address"];
        let payload = [_nftData.tokenId, _nftData.price]
        let hash = await createHash(types, payload)
        let signature = await handleSignMessageWithHash(hash, connectedAddress)
        const myNewData = await tokenContract.methods
            .cancelOfferBid(_nftData.tokenId, hash, signature)
            .encodeABI();
        const gasLimit = await web3.eth.estimateGas({
            from: connectedAddress,
            nonce: txCount,
            to: nftContractAddress,
            data: myNewData,
        });
        const gas2 = await web3.eth.getGasPrice();
        const transactionParameters = {
            nonce: web3.utils.toHex(txCount), // ignored by MetaMask
            gasPrice: web3.utils.toHex(gas2), // customizable by user during MetaMask confirmation.
            gasLimit: web3.utils.toHex(gasLimit), // customizable by user during MetaMask confirmation.
            to: nftContractAddress, // Required except during contract publications.
            from: connectedAddress, // must match user's active address.
            data: myNewData, // Optional, but used for defining smart contract creation and interaction.
        };
        // As with any RPC call, it may throw an error
        const txHash = await window.ethereum.request({
            method: 'eth_sendTransaction',
            params: [transactionParameters],
        });
        let txDetails = await getTransactionDetails(txHash)
        if (!txDetails.status) {
            return false;
        }
        return true;
    } catch (e) {
        console.log(e);
        let eMessage = e.message.split('{')[0] || '';
        toast.error(eMessage);
        return false;
    }
}
export const acceptOfferWeb3 = async (_nftData, offerByAddress, payThrough) => {
    const web3 = await getWeb3();
    if (!web3) {
        toast.error("No web3 instance found");
        return false;
    }
    try {
        let connectedAddress = await connectMetamask();
        let tokenContract = new Contract(contractAbi, nftContractAddress);
        const txCount = await web3.eth.getTransactionCount(connectedAddress);
        let types = ["uint256", "address"];
        let payload = [_nftData.tokenId, _nftData.price]
        let hash = await createHash(types, payload)
        let signature = await handleSignMessageWithHash(hash, connectedAddress)
        const myNewData = await tokenContract.methods
            .transferByAcceptOffer(_nftData.tokenId, offerByAddress, hash, signature, payThrough)
            .encodeABI();
        // const gasLimit = await web3.eth.estimateGas({
        //     from: connectedAddress,
        //     nonce: txCount,
        //     to: nftContractAddress,
        //     data: myNewData,
        // });
        // const gas2 = await web3.eth.getGasPrice();
        let weiPrice = web3.utils.toWei(`${_nftData.price}`, 'ether');
        const transactionParameters = {
            nonce: web3.utils.toHex(txCount), // ignored by MetaMask
            // gasPrice: web3.utils.toHex(gas2), // customizable by user during MetaMask confirmation.
            // gasLimit: web3.utils.toHex(gasLimit), // customizable by user during MetaMask confirmation.
            to: nftContractAddress, // Required except during contract publications.
            from: connectedAddress, // must match user's active address.
            data: myNewData, // Optional, but used for defining smart contract creation and interaction.
            value: web3.utils.toHex(weiPrice)
        };
        // As with any RPC call, it may throw an error
        const txHash = await window.ethereum.request({
            method: 'eth_sendTransaction',
            params: [transactionParameters],
        });
        let txDetails = await getTransactionDetails(txHash)
        if (!txDetails.status) {
            return false;
        }
        return txHash;
    } catch (e) {
        console.log(e);
        let eMessage = e.message.split('{')[0] || '';
        toast.error(eMessage);
        return false;
    }
}
export const acceptBidWeb3 = async (_nftData, offerByAddress, payThrough) => {
    const web3 = await getWeb3();
    if (!web3) {
        toast.error("No web3 instance found");
        return false;
    }
    try {
        let connectedAddress = await connectMetamask();
        let tokenContract = new Contract(contractAbi, nftContractAddress);
        const txCount = await web3.eth.getTransactionCount(connectedAddress);
        let types = ["uint256", "address"];
        let payload = [_nftData.tokenId, _nftData.price]
        let hash = await createHash(types, payload)
        let signature = await handleSignMessageWithHash(hash, connectedAddress)
        const myNewData = await tokenContract.methods
            .transferByBid(_nftData.tokenId, offerByAddress, hash, signature, payThrough)
            .encodeABI();
        // const gasLimit = await web3.eth.estimateGas({
        //     from: connectedAddress,
        //     nonce: txCount,
        //     to: nftContractAddress,
        //     data: myNewData,
        // });
        // const gas2 = await web3.eth.getGasPrice();
        let weiPrice = web3.utils.toWei(`${_nftData.price}`, 'ether');
        const transactionParameters = {
            nonce: web3.utils.toHex(txCount), // ignored by MetaMask
            // gasPrice: web3.utils.toHex(gas2), // customizable by user during MetaMask confirmation.
            // gasLimit: web3.utils.toHex(gasLimit), // customizable by user during MetaMask confirmation.
            to: nftContractAddress, // Required except during contract publications.
            from: connectedAddress, // must match user's active address.
            data: myNewData, // Optional, but used for defining smart contract creation and interaction.
            value: web3.utils.toHex(weiPrice)
        };
        // As with any RPC call, it may throw an error
        const txHash = await window.ethereum.request({
            method: 'eth_sendTransaction',
            params: [transactionParameters],
        });
        let txDetails = await getTransactionDetails(txHash)
        if (!txDetails.status) {
            return false;
        }
        return txHash;
    } catch (e) {
        console.log(e);
        let eMessage = e.message.split('{')[0] || '';
        toast.error(eMessage);
        return false;
    }
}
export const acceptBidWeb31 = async (_nftData) => {
    const web3 = await getWeb3();
    if (!web3) {
        toast.error("No web3 instance found");
        return false;
    }
    return true;
}
export const getApproval = async (guy, amount, contractAddress, contractABI) => {
    const web3 = await getWeb3();
    if (!web3) {
        toast.error("No web3 instance found");
        return false;
    }
    try {
        let connectedAddress = await connectMetamask();
        let contractInstance = new Contract(contractABI, contractAddress);
        const txCount = await web3.eth.getTransactionCount(connectedAddress);
        let weiPrice = web3.utils.toWei(`${amount}`, 'ether');
        const myNewData = await contractInstance.methods
            .approve(guy, weiPrice)
            .encodeABI();
        const gasLimit = await web3.eth.estimateGas({
            from: connectedAddress,
            nonce: txCount,
            to: contractAddress,
            data: myNewData,
        });
        const gas2 = await web3.eth.getGasPrice();
        const transactionParameters = {
            nonce: web3.utils.toHex(txCount), // ignored by MetaMask
            gasPrice: web3.utils.toHex(gas2), // customizable by user during MetaMask confirmation.
            gasLimit: web3.utils.toHex(gasLimit), // customizable by user during MetaMask confirmation.
            to: contractAddress, // Required except during contract publications.
            from: connectedAddress, // must match user's active address.
            data: myNewData, // Optional, but used for defining smart contract creation and interaction.
        };
        // As with any RPC call, it may throw an error
        const txHash = await window.ethereum.request({
            method: 'eth_sendTransaction',
            params: [transactionParameters],
        });
        let txDetails = await getTransactionDetails(txHash)
        if (!txDetails.status) {
            return false;
        }
        return true;
    } catch (e) {
        let eMessage = e.message.split('{')[0] || '';
        toast.error(eMessage);
        return false;
    }
}
export const isApproved = async (guy, connectedAddress, contractAddress, contractABI) => {
    const web3 = await getWeb3();
    if (!web3) {
        toast.error("No web3 instance found");
        return false;
    }
    try {
        let contractInstance = new Contract(contractABI, contractAddress);
        const myNewData = await contractInstance.methods
            .allowance(connectedAddress, guy)
            .call();
        return myNewData;
    } catch (e) {
        return 0;
    }
}
export const checkBalance = async (_nftData) => {
    const web3 = await getWeb3();
    if (!web3) {
        toast.error("No web3 instance found");
        return false;
    }
    try {
        let connectedAddress = await connectMetamask();
        let cabi = JSON.parse(_nftData.cabi);
        let cAddress = _nftData.cAddress;
        let contractInstance = new Contract(cabi, cAddress);
        const userBalance = await contractInstance.methods
            .balanceOf(connectedAddress)
            .call();
        return userBalance;
    } catch (e) {
        console.log(e);
        return 0;
    }
}
const getTransactionDetails = (txHash) => {
    try {
        return new Promise((resolve, reject) => {
            checkStatus();
            function checkStatus() {
                const web3 = new Web3(Web3.givenProvider);
                web3.eth.getTransactionReceipt(txHash, async function (err, result) {
                    if (!result) {
                        await sleep(4000);
                        checkStatus();
                    } else {
                        resolve(result);
                    }
                });
            }
        });
    } catch (e) {
        console.log("error");
    }
};
const sleep = async (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};
const handleSignMessage = async (address) => {
    return new Promise(async (resolve, reject) => {
        try {
            const web3 = await getWeb3();
            web3.eth.personal.sign(
                web3.utils.fromUtf8(`${ENV.appName} uses this cryptographic signature in place of a password, verifying that you are the owner of this address.`),
                address,
                (err, signature) => {
                    if (err) return reject(err);
                    return resolve(signature);
                }
            )
        }
        catch (e) {
            console.log(e);
        }
    });
};
const handleSignMessageWithHash = async (hash, address) => {
    return new Promise(async (resolve, reject) => {
        try {
            const web3 = await getWeb3();
            web3.eth.personal.sign(
                hash,
                address,
                (err, signature) => {
                    if (err) return reject(err);
                    return resolve(signature);
                }
            )
        }
        catch (e) {
            console.log(e);
        }
    });
};
async function createHash(types, data) {
    // var hash = "0x" + abi.soliditySHA3(
    //     types,
    //     data
    // ).toString('hex');
    // return hash;
    const web3 = await getWeb3();
    const hash = await web3.utils.soliditySha3(
        { t: "string", v: "Hello!111%" },
        { t: "int8", v: -23 },
        { t: "address", v: "0x85F43D8a49eeB85d32Cf465507DD71d507100C1d" }
    );
    return hash;
}
const accountsChangedHandler = async () => {
    if (window.ethereum) {
        window.ethereum.on('accountsChanged', function (accounts) {
            localStorage.clear()
            store.dispatch(redirectToWallet())
        })
        window.ethereum.on('chainChanged', function (_chainId) {
            let chaindId = parseInt(_chainId, 16);
            if (requiredChainId === chaindId) {
                store.dispatch(setWalletError(""));
            }
            else {
                store.dispatch(setWalletError(`Please switch to ${ENV.requiredChainName} in order to use all features of Marketplace`));
            }
        })
    }
}
const setWalletError = (message) => {
    return {
        type: SET_WALLET_ERROR,
        payload: message
    }
}
// redirect user to connect wallet
const redirectToWallet = () => {
    return {
        type: REDIRECT_TO_WALLET,
        payload: true
    }
}
accountsChangedHandler();